export const fieldActionTypes = {
  SET_FIELDS: 'SET_FIELDS'
}